var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BackButton',{staticClass:"u-margin-bottom-small"}),_c('SuggestionForm',{attrs:{"loadingSave":_vm.loadingSave},on:{"submit":function($event){return _vm.createSuggestion($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }